import { ref, watchEffect, type ComputedRef, type Ref } from 'vue';
import { phoneNumberMask } from '@/helpers/phoneNumberMask';
import { VITE_APP_SCOPE, VITE_APP_RESPONSE_TYPE } from '@/constants/url-params';
import { getConfigMemoized } from '@/helpers/axios';

export function useApiConnectAuthorize(
  isSmsFormCompleted: Ref<boolean>,
  clientId: ComputedRef<string>,
  redirectUri: ComputedRef<string>,
  smsCode: Ref<number>,
  phoneNumber: ComputedRef<string>,
  codeChallenge: ComputedRef<string>
): unknown {
  const data = ref();
  const smsError = ref();
  const isSmsDataCatched = ref(false);
  const scope = VITE_APP_SCOPE;
  const responseType = VITE_APP_RESPONSE_TYPE;

  async function doRequest() {
    if (isSmsFormCompleted.value) {
      data.value = undefined;
      smsError.value = undefined;

      try {
        switch (responseType) {
          case 'code': {
            const baseURL = (await getConfigMemoized()).VITE_APP_API_BASE_URL;

            const redirectUrl = `${baseURL}/connect/authorize?response_type=${responseType}&client_id=${
              clientId.value
            }&scope=${scope}&redirect_uri=${
              redirectUri.value
            }&PhoneNumber=${phoneNumberMask(phoneNumber.value)}&SmsCode=${
              smsCode.value
            }&code_challenge=${codeChallenge.value}&code_challenge_method=S256`;

            window.open(redirectUrl, '_self');
            break;
          }

          case 'token':
            // responseType token logic
            break;

          default:
            throw new Error('No response type');
        }
      } catch (error) {
        smsError.value =
          error.message || 'Произошла ошибка при выполнении запроса';
      }
    }
  }

  watchEffect(doRequest);

  return { isSmsDataCatched, data, smsError };
}
